'use client';

import { HorizontalOverflowCarousel } from '@petsmart-ui/sparky';
import type { SiteWidePromoBannerCarouselProps } from './types';

import './SiteWidePromoBannerCarousel.scss';

export default function SiteWidePromoBannerCarousel({ banners }: SiteWidePromoBannerCarouselProps) {
    return (
        <div className="sitewide-promo-carousel">
            <HorizontalOverflowCarousel
                perViewDefault={1}
                startAtDefault={0}
                breakpoints={{ 1200: { perView: 1, gap: 0 } }}
                animationDuration={1000}
                movementType="carousel"
                autoplay={5000}
            >
                {banners.map((banner, index) => (
                    <HorizontalOverflowCarousel.Item className="sitewide-promo-carousel__item" key={index}>
                        {banner}
                    </HorizontalOverflowCarousel.Item>
                ))}
            </HorizontalOverflowCarousel>
        </div>
    );
}
